<script>
  //Start
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";

  //send data to main
  const dispatch = createEventDispatcher();
  let position = {};

  let isValid = {};

  function validatePosition() {
    let allValid = true;
    position.side == "S" || position.side == "B" ? true : (allValid = false);

    position.type
      ? (isValid.type = "is-valid")
      : ((isValid.type = "is-invalid"), (allValid = false));
    position.expiry
      ? (isValid.expiry = "is-valid")
      : ((isValid.expiry = "is-invalid"), (allValid = false));
    position.lots
      ? (isValid.lots = "is-valid")
      : ((isValid.lots = "is-invalid"), (allValid = false));

    if (position.scrip) {
      let flag = false;
      for (let i = 0; i < scrips.length; i++) {
        if (position.scrip == scrips[i]) {
          flag = true;
        }
      }
      flag
        ? (isValid.scrip = "is-valid")
        : ((isValid.scrip = "is-invalid"), (allValid = false));
    } else {
      isValid.scrip = "is-invalid";
      allValid = false;
    }

    if (
      (position.type == "CALL" || position.type == "PUT") &&
      position.entryvalue > -2000
    ) {
      isValid.entryvalue = "is-valid";
    } else if (position.type == "CALL" || position.type == "PUT") {
      isValid.entryvalue = "is-invalid";
      allValid = false;
    }

    allValid ? addData() : alert("Fill All Details");
  }
  function addData() {
    if (position.entryvalue == 0) {
      position.entryvalue = "0";
    }
    Object.keys(position).forEach(
      (key) => position[key] == "" && delete position[key]
    );
    dispatch("message", position);
    reset();
    document.getElementById("closeModal").click();
  }

  function reset() {
    position = {};
    b = "";
    s = "";
    from = "";
    position.expiry = "";
    position.type = "";
    isValid = {};
    to = "";
  }
  function resetOptions() {
    from = "";
    to = "";
    isValid = {};
    position.entryvalue = "";
    position.entryby = "";
  }

  $: if (from && to) {
    position.entryvalue = from.toString() + "-" + to.toString();
  }
  let from;
  let to;

  let scripinfo = {};

  function getscripinfo() {
    let scripinfoget = JSON.parse(localStorage.getItem("scripsinfo"));
    scripinfo = scripinfoget[position.scrip];
    position.expiry = "";
  }
  let scrips;
  function load() {
    scrips = JSON.parse(localStorage.getItem("scrips"));
  }

  load();

  //Scrips

  //form
  let b;
  let s;
  $: if (position.side == "B") {
    b = "bg-green-lt";
    s = "";
  } else if (position.side == "S") {
    s = "bg-red-lt";
    b = "";
  }

  //end
  const types = ["FUT", "CALL", "PUT"];
</script>

<div
  class="modal modal-blur fade"
  id="modal-add"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Position</h5>
        <button
          type="button"
          class="btn-close"
          id="closeModal"
          on:click={reset}
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div class="modal-body">
        {#if scripinfo.lotsize && position.scrip != undefined}
          <div
            class="alert alert-info alert-dismissible"
            role="alert"
            in:fade
            out:fade
          >
            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-info-circle alert-icon"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
                <polyline points="11 12 12 12 12 16 13 16" />
              </svg>
              <div />
              <div>
                <h4 class="alert-title text-muted">
                  {#if position.scrip != undefined}
                    {position.scrip} lot size : {scripinfo.lotsize}
                  {/if}
                </h4>
                {#if position.expiry == "W" || position.expiry == "W1" || position.expiry == "W2" || position.expiry == "W3" || position.expiry == "W4" || position.expiry == "W5" || position.expiry == "W6" || position.expiry == "W7" || position.expiry == "W8"}
                  <h4 class="alert-title text-muted">
                    Weekly from {scripinfo.fromW}
                  </h4>
                {/if}
                {#if position.expiry == "M" || position.expiry == "M1" || position.expiry == "M2"}
                  <h4 class="alert-title text-muted">
                    Monthly from {scripinfo.fromM}
                  </h4>
                {/if}
              </div>
            </div>
          </div>
        {/if}
        <div class="row">
          <div class="col-lg-5">
            <div class="mb-3">
              <div class="form-selectgroup">
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    bind:group={position.side}
                    class="form-selectgroup-input {isValid.side}"
                    value="B"
                  />
                  <span class="form-selectgroup-label {b}">Buy</span>
                </label>
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    bind:group={position.side}
                    class="form-selectgroup-input {isValid.side}"
                    value="S"
                  />
                  <span class="form-selectgroup-label {s}">Sell</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <div class="input-group input-group-flat">
                <input
                  type="text"
                  bind:value={position.scrip}
                  class="form-control {isValid.scrip}"
                  placeholder="SYMBOL"
                  list="scrip-list"
                  on:blur={getscripinfo}
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <div class="mb-3">
              <select
                class="form-select {isValid.expiry}"
                bind:value={position.expiry}
              >
                <option value="" disabled selected>Expiry</option>
                {#if scripinfo.expiry}
                  {#each scripinfo.expiry as item}
                    <option value={item.id}>{item.text}</option>
                  {/each}
                {/if}
              </select>
            </div>
          </div>
          {#if scrips}
            <datalist id="scrip-list" style="height:3em;overflow:hidden">
              {#each scrips as scr}
                <option>{scr}</option>
              {/each}
            </datalist>
          {/if}
          <div class="col-lg-3">
            <div class="mb-3">
              <select
                class="form-select {isValid.type}"
                bind:value={position.type}
                on:blur={resetOptions}
              >
                <option value="" disabled selected>Type</option>
                {#each types as item}
                  <option value={item}>{item}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="mb-3">
              <input
                type="number"
                bind:value={position.lots}
                min="1"
                class="form-control {isValid.lots}"
                placeholder="Lots"
              />
            </div>
          </div>
          {#if position.type == "CALL" || position.type == "PUT"}
            <div class="col-lg-6">
              <div class="mb-3">
                <span class="form-label">Entry By</span>
                <div class="form-selectgroup">
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.entryby}
                      on:change={() => (
                        (position.entryvalue = ""), (from = ""), (to = "")
                      )}
                      class="form-selectgroup-input"
                      value="strike"
                    />
                    <span class="form-selectgroup-label">Strike</span>
                  </label>
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.entryby}
                      on:change={() => (position.entryvalue = "")}
                      class="form-selectgroup-input"
                      value="value"
                    />
                    <span class="form-selectgroup-label">Value</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-3">
                {#if position.entryby == "strike"}
                  <span class="form-label">Strike Price(ATM)</span>
                  <div class="input-group input-group-flat">
                    <span class="input-group-text">
                      ATM {#if position.entryvalue > 0} + {/if}
                    </span>
                    <input
                      type="number"
                      class="form-control ps-0 {isValid.entryvalue}"
                      bind:value={position.entryvalue}
                      autocomplete="off"
                    />
                  </div>
                {/if}
                {#if position.entryby == "value"}
                  <span class="form-label">Premium Range</span>
                  <div class="d-inline-flex">
                    <input
                      type="number"
                      style="width:35%;"
                      class="form-control d-inline-flex {isValid.entryvalue}"
                      min="0"
                      placeholder="From"
                      bind:value={from}
                    />
                    <div class="ms-3" />
                    <input
                      type="number"
                      style="width:35%;"
                      class="form-control d-inline-flex {isValid.entryvalue}"
                      min="0"
                      placeholder="To"
                      bind:value={to}
                    />
                  </div>
                {/if}
              </div>
            </div>
          {/if}
          <div class="mb-3">
            <div>
              <label class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  on:change={(() => (position.ptby = ""), (position.pt = ""))}
                  bind:checked={position.isPt}
                />
                <span class="form-check-label">Set Profit Target</span>
              </label>
              <label class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  on:change={(() => (position.slby = ""), (position.sl = ""))}
                  bind:checked={position.isSl}
                />
                <span class="form-check-label">Set Stop Loss</span>
              </label>
            </div>
          </div>
        </div>
        <!--Profit-->
        <div class="row">
          {#if position.isPt}
            <div class="col-lg-6">
              <div class="mb-3">
                <span class="form-label">Profit Target By</span>
                <div class="form-selectgroup">
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.ptby}
                      on:change={() => (position.pt = "")}
                      class="form-selectgroup-input"
                      value="percent"
                    />
                    <span class="form-selectgroup-label">Premium %</span>
                  </label>
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.ptby}
                      on:change={() => (position.pt = "")}
                      class="form-selectgroup-input"
                      value="points"
                    />
                    <span class="form-selectgroup-label">Premium Points</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-3">
                {#if position.ptby == "percent"}
                  <span class="form-label">Premium %</span>
                  <div class="input-group input-group-flat">
                    <input
                      type="number"
                      class="form-control text-end pe-3"
                      min="0"
                      bind:value={position.pt}
                      autocomplete="off"
                    />
                    <span class="input-group-text"> % </span>
                  </div>
                {/if}
                {#if position.ptby == "points"}
                  <span class="form-label">Premium Points</span>
                  <div class="input-group input-group-flat">
                    <span class="input-group-text"> ₹ </span>
                    <input
                      type="number"
                      min="0"
                      class="form-control ps-0"
                      bind:value={position.pt}
                      autocomplete="off"
                    />
                  </div>
                {/if}
              </div>
            </div>
          {/if}
          <!--Stop Loss-->
          {#if position.isSl}
            <div class="col-lg-6">
              <div class="mb-3">
                <span class="form-label">Stop Loss By</span>
                <div class="form-selectgroup">
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.slby}
                      on:change={() => (position.sl = "")}
                      class="form-selectgroup-input"
                      value="percent"
                    />
                    <span class="form-selectgroup-label">Premium %</span>
                  </label>
                  <label class="form-selectgroup-item">
                    <input
                      type="radio"
                      bind:group={position.slby}
                      on:change={() => (position.sl = "")}
                      class="form-selectgroup-input"
                      value="points"
                    />
                    <span class="form-selectgroup-label">Premium Points</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-3">
                {#if position.slby == "percent"}
                  <span class="form-label">Premium %</span>
                  <div class="input-group input-group-flat">
                    <input
                      type="number"
                      class="form-control text-end pe-3"
                      max="0"
                      bind:value={position.sl}
                      autocomplete="off"
                    />
                    <span class="input-group-text"> % </span>
                  </div>
                {/if}
                {#if position.slby == "points"}
                  <span class="form-label">Premium Points</span>
                  <div class="input-group input-group-flat">
                    <span class="input-group-text"> - ₹ </span>
                    <input
                      type="number"
                      min="0"
                      class="form-control ps-0"
                      bind:value={position.sl}
                      autocomplete="off"
                    />
                  </div>
                {/if}
              </div>
            </div>
          {/if}
        </div>
      </div>

      <!--Second Part-->

      <div class="modal-footer">
        <button class="btn btn-danger" on:click={reset} data-bs-dismiss="modal">
          Cancel
        </button>
        <button class="btn btn-primary ms-auto" on:click={validatePosition}>
          <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
          Add
        </button>
      </div>
    </div>
  </div>
</div>
